import { atom } from 'recoil';

export const goodOptionListState = atom({
  key: 'goodOptionListStateMo',
  default: [],
});

export const goodTabInfoState = atom({
  key: 'goodTabInfoStateMo',
  default: 0,
});

export const newGoodListState = atom({
  key: 'newGoodListState',
  default: [],
});

export const goodSelectedRegularDelivery = atom({
  key: 'goodSelectedRegularDeliveryMo',
  default: {
    period: {
      code: '',
      name: '',
    },
    total: null,
    time: null,
    startDateTime: null,
  },
});
